import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { invalidateNavigationCache } from "../../api/apiSettings";

export const useInvalidateNavigationCache = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    return useMutation({
        mutationFn: () => invalidateNavigationCache(),
        onSuccess: (response) => {
            toast.success(
                response?.message ||
                (isArabic ? "تم تفريغ كاش التنقل" : "Navigation cache invalidated")
            );
        },
        onError: (error) => {
            const message =
                error?.response?.data?.message ||
                (isArabic ? "تعذر تفريغ كاش التنقل" : "Failed to invalidate navigation cache");
            toast.error(message);
        },
    });
};
